import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';
import { MinimalTarget } from '@/generated/model';

export type TargetAttributesContextType = {
  selectedTargets: MinimalTarget[] | undefined;
  setSelectedTargets: Dispatch<SetStateAction<MinimalTarget[] | undefined>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  maxTargetNumber: number;
  setMaxTargetNumber: Dispatch<SetStateAction<number>>;
};

export const ctxTargetAttributes = createContext<TargetAttributesContextType | undefined>(undefined);

export function TargetAttributesContext({ children }: { children: ReactElement }) {
  const [selectedTargets, setSelectedTargets] = useState<MinimalTarget[] | undefined>(undefined);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [maxTargetNumber, setMaxTargetNumber] = useState<number>(0);

  return (
    <ctxTargetAttributes.Provider
      value={{
        selectedTargets,
        setSelectedTargets,
        searchText,
        setSearchText,
        maxTargetNumber,
        setMaxTargetNumber,
      }}
    >
      {children}
    </ctxTargetAttributes.Provider>
  );
}
